import { motion } from "framer-motion";
import { Card, Col, Row } from "react-bootstrap";

import { useSelector } from "react-redux";

import Systolic from "../../../assets/img/blood-pressure.svg";
import Diastolic from "../../../assets/img/blood-pressure-check.svg";
import Weight from "../../../assets/img/sport.png";
import AdmissionWeight from "../../../assets/img/weight-loss.png";
import Height from "../../../assets/img/height.svg";
import Temperature from "../../../assets/img/icons/temp.svg";
import Oxygen from "../../../assets/img/oxygen-saturation.svg";
import BirthWeight from "../../../assets/img/bathroom-scale.png";
import Respiratory from "../../../assets/img/respiratory-system.svg";
import Pulse from "../../../assets/img/pulse.svg";
import Menstrual from "../../../assets/img/icons/menstrual-cycle.svg";
import Intensivist from "../../../assets/img/icons/intensivist.svg";
import Ventilation from "../../../assets/img/icons/ventilation.svg";
import LengthStay from "../../../assets/img/icons/time.svg";
const PreauthorizationVitalNested = () => {
  const { preauthorizationRequest } = useSelector(
    (state) => state.preauthorization
  );
  const { claimRequestData } = useSelector((state) => state.claim);

  const cliamPreauthorization =
    preauthorizationRequest?.entry?.find(
      (e) => e.resource?.resourceType === "Claim"
    )?.resource ||
    claimRequestData?.entry?.find((e) => e.resource?.resourceType === "Claim")
      ?.resource;

  const getVitalSignValue = (targetCode) => {
    const item = cliamPreauthorization?.supportingInfo.find((entry) =>
      entry.category?.coding?.some((coding) => coding.code === targetCode)
    );

    if (item?.valueQuantity) {
      return `${item?.valueQuantity?.value} ${item?.valueQuantity?.code}`;
    } else if (item?.valueDateTime) {
      return `${item?.valueDateTime}`;
    } else if (item?.code) {
      return `${item?.code?.coding[0]?.code}`;
    } else {
      return "";
    }
  };

  return (
    <motion.div
      style={{ border: "2px solid #d9f8eb" }}
      className="rounded p-3 position-relative mt-3 mb-3"
      initial={{ opacity: 0, y: 50 }} // Starts faded out and moved down
      animate={{ opacity: 1, y: 0 }} // Fades in and moves to place
      exit={{ opacity: 0, y: 50 }} // Optional: for exit animation
      transition={{ duration: 0.5 }} // Smooth transition
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Vital Sign</span>
        </span>
      </div>
      <Row className="mt-3 ">
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Systolic B.P"
            imageSrc={Systolic}
            bg="badge-subtle-danger"
            value={getVitalSignValue("vital-sign-systolic")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Diastolic B.P"
            imageSrc={Diastolic}
            bg="badge-subtle-warning"
            value={getVitalSignValue("vital-sign-diastolic")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Weight"
            imageSrc={Weight}
            bg="badge-subtle-success"
            value={getVitalSignValue("vital-sign-weight")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Admission Weight"
            imageSrc={AdmissionWeight}
            bg="badge-subtle-success"
            value={getVitalSignValue("admission-weight")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Height"
            imageSrc={Height}
            bg="badge-subtle-secondary"
            value={getVitalSignValue("vital-sign-height")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Temperature"
            imageSrc={Temperature}
            bg="badge-subtle-primary"
            value={getVitalSignValue("temperature")}
          />
        </Col>

        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="O2 Saturation"
            imageSrc={Oxygen}
            bg="badge-subtle-info"
            value={getVitalSignValue("oxygen-saturation")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Birth Weight"
            imageSrc={BirthWeight}
            bg="badge-subtle-danger"
            value={getVitalSignValue("birth-weight")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Respiratory Rate"
            imageSrc={Respiratory}
            bg="badge-subtle-success"
            value={getVitalSignValue("respiratory-rate")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Pulse"
            imageSrc={Pulse}
            bg="badge-subtle-secondary"
            value={getVitalSignValue("pulse")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Last Menstrual Period"
            imageSrc={Menstrual}
            bg="badge-subtle-primary"
            value={getVitalSignValue("last-menstrual-period")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="ICU Hours"
            imageSrc={Intensivist}
            bg={"badge-subtle-info"}
            value={getVitalSignValue("icu-hours")}
          />
        </Col>

        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Ventilation Hours"
            imageSrc={Ventilation}
            bg="badge-subtle-primary"
            value={getVitalSignValue("ventilation-hours")}
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl={3} className="mb-3">
          <VitalSignItem
            title="Estimated Length of Stay"
            imageSrc={LengthStay}
            bg="badge-subtle-secondary"
            value={getVitalSignValue("estimated-Length-of-Stay")}
          />
        </Col>
      </Row>
    </motion.div>
  );
};

export default PreauthorizationVitalNested;

const VitalSignItem = ({ title, value, imageSrc, bg }) => {
  return (
    <Card className="p-3">
      <div className="d-flex justify-content-between align-items-center">
        {/* Image on the left */}
        <div
          style={{
            borderRadius: "10px",
            padding: "8px",
          }}
          className={`d-flex align-items-center justify-content-center ${bg}`}
        >
          <img
            src={imageSrc}
            style={{ width: "30px", height: "30px" }}
            alt="icon"
          />
        </div>

        {/* Text content on the right */}
        <div className="d-flex flex-column gap-1 text-end">
          <span className="fw-normal fs-10">{title}</span>
          <span className="fw-bolder text-400 fs-9">{value}</span>
        </div>
      </div>
    </Card>
  );
};
